/* =====================================================================
   STICKERPACK HEADER + CART DRAWER — CONFIG BLOCK
   ===================================================================== */
window.SPHeaderConfig = {
  // Free UK Standard delivery from this cart total. Drives the progress box at
  // the top of the drawer (snippets/sp-free-delivery.liquid); keep in step with
  // shopify/shipping.js. Set to null to hide the box entirely.
  freeShippingThresholdGbp: 20,
};

/* =====================================================================
   IMPLEMENTATION
   ===================================================================== */
(function () {
  'use strict';

  var els = {
    shade: document.querySelector('[data-sp-shade]'),
    menuDrawer: document.querySelector('[data-sp-menu-drawer]'),
    cartDrawer: document.querySelector('[data-sp-cart-drawer]'),
    menuOpenBtn: document.querySelector('[data-sp-menu-open]'),
    menuCloseBtn: document.querySelector('[data-sp-menu-close]'),
    cartOpenBtn: document.querySelector('[data-sp-cart-open]'),
    cartCloseBtn: document.querySelector('[data-sp-cart-close]'),
    cartCount: document.querySelector('[data-sp-cart-count]'),
    cartDrawerCount: document.querySelector('[data-sp-cart-drawer-count]'),
    cartList: document.querySelector('[data-sp-cart-list]'),
    cartFoot: document.querySelector('[data-sp-cart-foot]'),
    cartSubtotal: document.querySelector('[data-sp-cart-subtotal]'),
    cartShip: document.querySelector('[data-sp-cart-ship]'),
  };

  if (!els.shade) return; // header snippet not present on this page

  function gbp(cents) {
    return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(cents / 100);
  }

  function openMenu() { els.menuDrawer.classList.add('sp-open'); els.shade.classList.add('sp-open'); }
  function closeMenu() { els.menuDrawer.classList.remove('sp-open'); els.shade.classList.remove('sp-open'); }
  function openCart() { els.cartDrawer.classList.add('sp-open'); els.shade.classList.add('sp-open'); }
  function closeCart() { els.cartDrawer.classList.remove('sp-open'); els.shade.classList.remove('sp-open'); }
  function closeAll() { closeMenu(); closeCart(); }

  if (els.menuOpenBtn) els.menuOpenBtn.addEventListener('click', openMenu);
  if (els.menuCloseBtn) els.menuCloseBtn.addEventListener('click', closeMenu);
  if (els.cartOpenBtn) els.cartOpenBtn.addEventListener('click', function () { openCart(); refreshCart(); });
  if (els.cartCloseBtn) els.cartCloseBtn.addEventListener('click', closeCart);
  els.shade.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  // Material / size / pack live in the variant title; the rest are the
  // configurator's line-item properties (file uploads are left out).
  function propertyLine(item) {
    var parts = item.variant_title ? item.variant_title.split(' / ') : [];
    var properties = item.properties || {};
    ['Shape', 'Cut', 'Border', 'Background'].forEach(function (key) {
      if (properties[key]) parts.push(properties[key]);
    });
    if (properties.Artwork) parts.push('🎨 ' + String(properties.Artwork).split('/').pop().split('?')[0]);
    return parts.join(' · ');
  }

  // Free delivery progress box at the top of the drawer (markup from sp-free-delivery.liquid).
  function renderShip(totalPence) {
    var threshold = window.SPHeaderConfig.freeShippingThresholdGbp;
    var box = els.cartShip && els.cartShip.querySelector('[data-sp-ship]');
    if (!box) return;
    if (threshold == null) { els.cartShip.hidden = true; return; }
    els.cartShip.hidden = false;
    var left = threshold * 100 - totalPence;
    box.classList.toggle('sp-ship--done', left <= 0);
    box.querySelector('[data-sp-ship-fill]').style.width = Math.min(100, Math.round(totalPence / threshold)) + '%';
    box.querySelector('[data-sp-ship-head]').innerHTML = left > 0
      ? 'You’re <em>' + gbp(left) + '</em> away from free UK delivery'
      : '🎉 You’ve unlocked <em>free UK delivery</em>';
    box.querySelector('[data-sp-ship-note]').textContent = left > 0
      ? 'Spend £' + threshold + ' and we post it free.'
      : 'Your order goes free with Standard UK delivery.';
  }

  function renderCart(cart) {
    els.cartDrawerCount.textContent = '(' + cart.item_count + ')';
    els.cartCount.style.display = cart.item_count > 0 ? 'grid' : 'none';
    els.cartCount.textContent = cart.item_count;

    if (cart.item_count === 0) {
      els.cartList.innerHTML =
        '<div class="sp-cart-empty"><div style="font-size:44px">🛍️</div><b>Your cart is waiting.</b><p>Upload your design and see an instant proof in seconds.</p><a class="sp-button sp-yellow" href="/#quote" data-sp-cart-close-link>Get an instant quote →</a></div>';
      els.cartFoot.style.display = 'none';
      if (els.cartShip) els.cartShip.hidden = true;
      return;
    }

    els.cartList.innerHTML = cart.items
      .map(function (item) {
        var detail = propertyLine(item);
        return (
          '<article class="sp-cart-item" data-sp-cart-line="' + item.key + '">' +
          '<div class="sp-cart-emoji">🏷️</div>' +
          '<div><h3>' + item.product_title + '</h3>' +
          (detail ? '<p>' + detail + '</p>' : '') +
          '<strong>' + gbp(item.final_line_price) + '</strong></div>' +
          '<button class="sp-cart-remove" data-sp-cart-remove aria-label="Remove ' + item.product_title + '">×</button>' +
          '</article>'
        );
      })
      .join('');

    els.cartFoot.style.display = 'block';
    els.cartSubtotal.textContent = gbp(cart.total_price);

    renderShip(cart.total_price);

    els.cartList.querySelectorAll('[data-sp-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = btn.closest('[data-sp-cart-line]').getAttribute('data-sp-cart-line');
        changeLine(line, 0);
      });
    });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(renderCart)
      .catch(function () {
        /* Cart is queried purely for display — if it fails, leave whatever
           was last rendered rather than showing a broken drawer. */
      });
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line, quantity: quantity }),
    })
      .then(function (res) { return res.json(); })
      .then(renderCart);
  }

  // The sticker configurator dispatches this after a successful add-to-cart
  // so the drawer opens and shows the new line without a page reload.
  document.addEventListener('sticker:added-to-cart', function () {
    refreshCart();
    openCart();
  });

  refreshCart();

  // Clicking 'Get an instant quote' in the empty cart: close the drawer
  // so the builder underneath is visible.
  els.cartList.addEventListener('click', function (e) {
    if (e.target.closest('[data-sp-cart-close-link]')) closeCart();
  });

  // Mobile 'Get an instant quote' bar: hidden while the builder itself is
  // on screen or a drawer is open, so it never covers what it points to.
  var stickyCta = document.querySelector('[data-sp-sticky-cta]');
  if (stickyCta) {
    var builderVisible = false;
    var updateSticky = function () {
      var drawerOpen = els.shade.classList.contains('sp-open');
      stickyCta.classList.toggle('sp-hidden', builderVisible || drawerOpen || window.scrollY < 200);
    };
    // The header renders before the page content, so look for the builder
    // once the rest of the page exists.
    var watchBuilder = function () {
      var builder = document.querySelector('[data-sp-configurator]');
      if (!builder || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        builderVisible = entries[0].isIntersecting;
        updateSticky();
      }).observe(builder);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBuilder);
    else watchBuilder();
    window.addEventListener('scroll', updateSticky, { passive: true });
    new MutationObserver(updateSticky).observe(els.shade, { attributes: true, attributeFilter: ['class'] });
    updateSticky();
  }

  window.SPCart = { open: openCart, close: closeCart, refresh: refreshCart };
})();
